import { render, staticRenderFns } from "./CookiesBanner.vue?vue&type=template&id=7ff37521&scoped=true&"
import script from "./CookiesBanner.vue?vue&type=script&lang=js&"
export * from "./CookiesBanner.vue?vue&type=script&lang=js&"
import style0 from "./CookiesBanner.vue?vue&type=style&index=0&id=7ff37521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff37521",
  null
  
)

export default component.exports